import React from 'react';
import times from 'lodash/times';

import Table from 'components/shared/table';

import TableLoadingCell from 'components/shared/index/TableLoadingCell';
import ElementHeader from './ElementHeader';
import ElementRow from './ElementRow';

const tableHeaders = [
  {
    label: t('common.title'),
    name: 'title',
    size: 'xl',
    loadingPlaceholder: {
      width: 55,
    },
  },
  {
    label: t('common.type'),
    name: 'content_type',
    size: 'l',
    loadingPlaceholder: {
      width: 45,
    },
  },
  {
    label: t('common.last_updated'),
    name: 'last_modified',
    size: 's',
    sortType: 'numeric',
    loadingPlaceholder: {
      width: 25,
      roleTag: { width: 75 },
    },
  },
  {
    label: t('contents.library.table.sections_used'),
    name: 'sections_used',
    contentClassName: 'ai-c',
    size: 's',
    sortType: 'numeric',
    loadingPlaceholder: {
      width: 15,
    },
  },
];

const ElementTable = ({
  loading,
  setSort,
  sort,
  elements,
  page,
  totalPages,
  setPerPage,
  perPage,
  setPage,
}) => (
  <Table className="mt-24 mb-32" alternate>
    <Table.Body>
      <ElementHeader onSort={setSort} sort={sort} tableHeaders={tableHeaders} />
      {loading &&
        times(3, i => (
          <Table.Row key={i}>
            {tableHeaders.map(cell => (
              <TableLoadingCell
                key={cell.name}
                contentClassName={cell.contentClassName}
                size={cell.size}
                roleTag={cell.loadingPlaceholder.roleTag}
                width={cell.loadingPlaceholder.width}
              />
            ))}
          </Table.Row>
        ))}
      {!loading &&
        elements.map(element => <ElementRow key={element.id} {...element} />)}
    </Table.Body>
    <Table.Footer>
      <Table.Pagination
        className="w-a"
        page={page}
        pageCount={totalPages}
        onPageChange={selectedPage => {
          setPage(selectedPage);
        }}
      />
      {!loading && <Table.PerPage onChange={setPerPage} value={perPage} />}
    </Table.Footer>
  </Table>
);

export default ElementTable;
